<template>
  <div class="m-t-15">
    <!--主内容区-->
    <div class="card">
      <div class="section">
        <base-section-title class="section-title" title="采购方案信息" />

        <div class="section-content">
          <jczh-descriptions
            :el-attrs="{ column: 3 }"
            :info="formData"
            :option="options"
          />
        </div>
      </div>
    </div>

    <div class="card">
      <div class="section">
        <base-section-title class="section-title" title="内部附件上传" />

        <div class="section-content">
          <jczh-descriptions
            :el-attrs="{ column: 3 }"
            :info="formData"
            :option="fileOptions"
          >
            <template v-slot:internalAttachmentIds>
              <upload
                v-if="formData.internalAttachmentIds"
                :file-id-before="formData.internalAttachmentIds"
                :props-data="{
                  disabled: true,
                  uploadMode: 'fileId'
                }"
              />
              <span v-else>-</span>
            </template>
          </jczh-descriptions>
        </div>
      </div>
    </div>

    <div
      v-if="formData.openType === purchasePlanRangeOfSupplierDict.INVITE.value"
      class="card"
    >
      <div class="section">
        <base-section-title class="section-title" title="推荐供应商" />

        <div class="detail-content-width m-l-40">
          <jczh-table-content
            :data="pageSupplierList"
            :option="supplierOption"
            pagination
            :total="supplierList.length"
            :page.sync="page"
            :limit.sync="size"
            @pagination="getPageData"
          />
        </div>
      </div>
    </div>

    <div class="card">
      <div class="section">
        <base-section-title class="section-title" title="品目信息" />

        <material-item-table
          :table-list="formData.itemList"
          :table-config-fun="() => tableOption"
          :show-operation="false"
          :selection="false"
        >
          <template v-slot:price="{ row }">
            <span
              v-if="
                Object.prototype.toString.call(row.price) === '[object Object]'
              "
            >
              {{ strToThousands(row.price.noRateWinPrice) }}
              <span v-if="row.price.winTime">({{ row.price.winTime }})</span>
              |
              <el-button type="text" @click="openDrawer(row)">
                历史价格
              </el-button>
            </span>
            <span v-else>-</span>
          </template>

          <template v-slot:subType="{ row }">
            {{ getSubTypeLabel(row.subType) }}
          </template>
        </material-item-table>
      </div>
    </div>
    <!--    查看历史价格-->
    <lowest-price-drawer
      v-model="isDrawerShow"
      :is-edit="false"
      :row-data="rowData"
      :picker-options="pickerOptions"
      :is-limit="hasDirect"
    />

    <!-- 审批备注 -->
    <record-remark
      v-if="requestQuery.pageFrom == 'auditDetail'"
      class="m-t-16"
      :remark-list="remarkList"
    />
  </div>
</template>

<script>
// 组件
import BaseSectionTitle from '@/components/common/BaseSectionTitle'
import MaterialItemTable from '@/components/common/MaterialComponent/MaterialItemTable'
import LowestPriceDrawer from '@/components/purchase-demand/LowestPriceDrawer'
import RecordRemark from '@/components/common/RecordRemark'
import Upload from '@/components/common/Upload/index'
// 数据字典
import {
  projectTypeDict,
  whetherBooleanDict
} from '@/dictionary/project/common'
import {
  purchasePlanTypeDict,
  purchasePlanMethodDict,
  purchasePlanRangeOfSupplierDict,
  purchasePlanCategoryDict,
  purchaseDemandSubTypeDict,
  purchaseStatusDict
} from '@/dictionary/purchase-demand'

// 工具函数
import { strToThousands } from '@/utils/utils.js'
import dayjs from 'dayjs'

// 后端api接口
import { getPurchasePlanDetailApi } from '@/api/purchase-demand/plan'

export default {
  name: 'PlanDetail',

  components: {
    BaseSectionTitle,
    MaterialItemTable,
    LowestPriceDrawer,
    RecordRemark,
    Upload
  },

  props: {
    requestQuery: {
      type: Object,
      required: true
    },

    // 备注列表
    remarkList: {
      type: Array,
      default: () => {
        return []
      }
    }
  },

  data() {
    return {
      // 数据字典
      projectTypeDict,
      whetherBooleanDict,
      purchasePlanTypeDict,
      purchasePlanMethodDict,
      purchasePlanRangeOfSupplierDict,
      purchasePlanCategoryDict,

      // 方案id
      formData: {},
      options: [
        { label: '方案名称', prop: 'planName', elAttrs: { span: 3 } },
        { label: '方案编号', prop: 'planCode' },
        {
          label: '采购类型',
          prop: 'programType',
          filter: value => purchasePlanTypeDict.translate(value).label || '-'
        },
        {
          label: '采购方式',
          prop: 'purchaseMethod',
          filter: value => purchasePlanMethodDict.translate(value).label || '-'
        },
        {
          label: '项目类型',
          prop: 'projectType',
          filter: value => projectTypeDict.translate(value)?.demandLabel || projectTypeDict.translate(value)?.label
        },
        {
          label: '最小供应商数量',
          prop: 'minBid',
          hideFun: () =>
            !(this.formData.purchaseMethod && this.formData.purchaseMethod === purchasePlanMethodDict.INQUIRY.value)
        },
        {
          label: '供应商范围',
          prop: 'openType',
          filter: value =>
            purchasePlanRangeOfSupplierDict.translate(value).label || '-',
          hideFun: () =>
            !(this.formData.purchaseMethod && this.formData.purchaseMethod === purchasePlanMethodDict.INQUIRY.value)
        },
        {
          label: '采购类别',
          prop: 'categoryCode',
          filter: value =>
            purchasePlanCategoryDict.translate(value).label || '-'
        },
        { label: '采购执行人', prop: 'executorName', elAttrs: { span: 2 } },
        { label: '备注说明', prop: 'formulateRemark', elAttrs: { span: 3 } }
      ],

      fileOptions: [
        { label: '内部附件上传', prop: 'internalAttachmentIds', slotName: 'internalAttachmentIds', elAttrs: { span: 3 } }
      ],

      // 供应商列表
      supplierList: [],
      pageSupplierList: [],
      page: 1,
      size: 10,
      total: 0,
      supplierOption: [
        { label: '供应商名称', prop: 'supplierName' },
        { label: '联系人', prop: 'contactUserName' },
        { label: '联系电话', prop: 'contactUserPhone' }
      ],

      // 历史最低价
      isDrawerShow: false,
      rowData: null,

      // 历史价限制时间范围
      priceTimeRange: {
        startTime: new Date(dayjs().subtract(1, 'year').startOf('date')),
        endTime: new Date(dayjs().endOf('date'))
      }
    }
  },

  computed: {
    // 定点采购情况
    hasAppoint() {
      return (
        this.formData.programType === purchasePlanTypeDict.PROTOCOL.value &&
        this.formData.purchaseMethod === purchasePlanMethodDict.ORDER.value
      )
    },

    // 直接采购情况
    hasDirect() {
      return (
        this.formData.programType === purchasePlanTypeDict.SINGLE.value &&
        this.formData.purchaseMethod === purchasePlanMethodDict.DIRECT.value
      )
    },

    // 品目变量 -- 表格配置
    tableOption() {
      return [
        { label: '申请单编号', prop: 'requirementCode', minWidth: 100 },
        { label: '品目编码', prop: 'itemCode', minWidth: 100 },
        { label: '品目名称', prop: 'itemName', minWidth: 100 },
        { label: '参数型号', prop: 'itemModel', minWidth: 100 },
        { label: '品牌/制造商', prop: 'itemBrand', minWidth: 100 },
        { label: '品目单位', prop: 'unitType' },
        { label: '数量', prop: 'itemNum' },
        {
          label: '预算不含税单价(元)',
          prop: 'unitPrice',
          filter: value => strToThousands(value),
          minWidth: 160
        },
        { label: '税率 %', prop: 'taxRate' },
        { label: '历史不含税最低价(元)', slotName: 'price', minWidth: 300 },
        {
          label: '预算不含税总价(元)',
          prop: 'totalPrice',
          filter: value => strToThousands(value),
          minWidth: 160
        },
        /**
         * 直接采购
         */
        {
          label: '供应商名称',
          hide: !this.hasDirect,
          prop: 'price',
          filter: value => value.winSupplierName || '-',
          minWidth: 160
        },
        {
          label: '不含税成交单价(元)',
          hide: !this.hasDirect,
          prop: 'price',
          filter: value => value.noRateWinPrice || '-',
          minWidth: 160
        },
        {
          label: '成交税率(%)',
          hide: !this.hasDirect,
          prop: 'price',
          filter: value => value.winTaxRate || '-',
          minWidth: 160
        },
        {
          label: '供货时间(天)',
          hide: !this.hasDirect,
          prop: 'price',
          filter: value => value.supplyTime || value.supplyTime == 0 ? value.supplyTime : 15,
          minWidth: 160
        },
        /**
         * 定点采购
         */
        {
          label: '框架协议',
          prop: 'agreement',
          hide: !this.hasAppoint,
          minWidth: 140,
          filter: value => value?.agreementCode || '-'
        },
        {
          label: '中标供应商',
          hide: !this.hasAppoint,
          prop: 'agreement',
          filter: value => value.supplierName || '-',
          minWidth: 160
        },
        {
          label: '协议不含税单价(元)',
          hide: !this.hasAppoint,
          prop: 'agreement',
          filter: value => value.agreementPrice || '-',
          minWidth: 160
        },
        {
          label: '协议税率(%)',
          hide: !this.hasAppoint,
          prop: 'agreement',
          filter: value => value.agreementTaxRate || '-',
          minWidth: 130
        },
        { label: '工厂编码', prop: 'factory' },
        {
          label: '交货地点',
          prop: 'deliveryAddress',
          minWidth: 100,
          filter: value => (value ? value.split(',')?.[1] || '-' : '-')
        },
        { label: '交货时间(天)', prop: 'deliveryDay', minWidth: 120 },
        { label: '使用部门', prop: 'useDept' },
        { label: '科目分配类别', prop: 'subType', slotName: 'subType', width: 140 },
        {
          label: '采购状态',
          prop: 'purchaseStatus',
          tagDict: purchaseStatusDict,
          width: 140
        }
      ]
    },

    /**
     * 历史最低价时间选择限制
     */
    pickerOptions() {
      // 直接采购,限制只能选择一年内时间
      if (this.hasDirect) {
        return {
          disabledDate: (time) => {
            const start = this.priceTimeRange.startTime.getTime()
            const end = this.priceTimeRange.endTime.getTime()
            const current = new Date(time).getTime()
            if (current >= start && current <= end) {
              return false
            }
            return true
          }
        }
      }
      return {}
    }
  },

  watch: {
    'requestQuery.id': {
      handler(newVal) {
        this.getPurchasePlanDetail()
      },

      immediate: true
    }
  },

  methods: {
    strToThousands,
    /**
     * (编辑时）获取采购方案详情
     */
    getPurchasePlanDetail() {
      if (!this.requestQuery.planId) return

      getPurchasePlanDetailApi(this.requestQuery.planId)
        .then(res => {
          this.formData = res?.data || {}
          this.$emit('getDetail', this.formData)
          this.supplierList = this.formData.supplierList || []
          this.getPageData()
        })
        .catch(err => {
          this.$message.error(err?.message || '获取采购方案详情失败')
        })
    },

    /**
     * @description: 前端分页，获取当前页数据
     * @param {*}
     * @return {*}
     */
    getPageData() {
      const start = (this.page - 1) * this.size
      const end = start + this.size
      this.pageSupplierList = this.supplierList.slice(start, end)
    },
    openDrawer(row) {
      this.rowData = row
      this.isDrawerShow = true
    },

    // 科目分配类别
    getSubTypeLabel(value) {
      return value
        ? purchaseDemandSubTypeDict.translate(value)?.label
        : value == purchaseDemandSubTypeDict.BLANK.value
          ? purchaseDemandSubTypeDict.BLANK.label
          : '-'
    }
  }
}
</script>

<style scoped lang="scss">
.tag-wrapper {
  margin-right: 8px;
  margin-bottom: 4px;
}
</style>
